<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>

				<sales-group class="mgr_15" v-model="salesGroupCode" ref="salesGroup" :allSelect="false" />

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>

				<select-user-defined-group v-model="userDefinedGroups" ref="userDefinedGroup" @change="userDefinedGroupAll" />
			</div>
		</div>

		<table class="list_tbl" id="excelTable">
			<tbody>
				<template v-for="sales in root">
					<tr :key="sales.sales_group_code">
						<td colspan="1000" class="bold_t">{{ sales.sales_group_code }} / {{ sales.sales_group_name }} {{ sales.from_date }} ~ {{ sales.to_date }}</td>
					</tr>
					<tr :key="sales.sales_group_code + '_partner'">
						<td>User Defined Group</td>
						<template v-for="(partner, index3) in sales.partners">
							<td class="al_center bold_t" :key="sales.sales_group_code + '_partner_' + index3">{{ partner.partner_code }}</td>
						</template>
						<td class="al_center bold_t">GRAND TOTAL</td>
					</tr>
					<tr v-for="cls in sales.classes" :key="sales.sales_group_code + cls.class_code">
						<td>{{ cls.class_name }}</td>
						<template v-for="partner in sales.partners">
							<td class="al_right" :key="sales.sales_group_code + cls.class_code + partner.partner_code">{{ sales[partner.partner_code][cls.class_code] | toCurrency }}</td>
						</template>
						<td class="al_right">{{ cls.totalAmt | toCurrency }}</td>
					</tr>
					<tr :key="sales.sales_group_code + 'bottom'">
						<td>GRAND TOTAL</td>
						<td class="al_right" v-for="partner in sales.partners" :key="'bottom' + sales.sales_group_code + partner.partner_code">
							{{ partner.totalAmt | toCurrency }}
						</td>
						<td class="al_right">{{ sales.sumTotalAmt | toCurrency }}</td>
					</tr>
				</template>
			</tbody>
		</table>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="groupExcel()">Excel</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="groupPrint()">Print</a>
				</li>
				<li>
					<label>
						<input type="checkbox" v-model="div_by_state" />
						<em class="lt_text">Print Divided by State</em>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import SalesGroup from '@/components/common/SalesGroup';
import { exportExcel, objectToFormData, reportMrtUrl, reportRenderHorizontally, excelComplicated } from '@/api/util';
import { apiLandingRegionGroup } from '@/api/report/report';
import { today } from '@/utils/date';
import SelectUserDefinedGroup from '@/components/common/SelectUserDefinedGroup';

import XLSX from 'xlsx-js-style';

export default {
	name: 'LandingRegionGroup',
	data: function() {
		return {
			fromDate: today(),
			toDate: today(),
			salesGroupCode: '',
			root: [],
			group: [],
			userDefinedGroups: [],
			all: false,

			udg_list: [],
			div_by_state: false,
		};
	},
	components: {
		SelectUserDefinedGroup,
		CustomDatePicker,
		SalesGroup,
	},
	methods: {
		async search() {
			if (!this.all && this.userDefinedGroups.length < 1) {
				this.$toast.error('User Defined Group is empty.');
				return false;
			}
			const param = {
				from_date: this.fromDate,
				to_date: this.toDate,
				sales_group_code: this.salesGroupCode,
				userDefinedGroups: this.userDefinedGroups,
			};
			const { data } = await apiLandingRegionGroup(objectToFormData(param));
			this.udg_list = data.udg_list.map(udg => ({ class_code: String(udg.udNo), class_name: udg.name }));
			this.root = this.reorganizeData(data.result);

			this.root.forEach(function(value) {
				value.group = true;
			});
		},
		reorganizeData(data) {
			data.forEach(el => {
				const print_item_list = [];
				let sumTotalAmt = 0;
				el.classes = _.cloneDeep(this.udg_list);
				el.partner_cnt = el.partners.length;
				el.class_cnt = el.classes.length;

				el.partners.forEach(p => {
					p.totalAmt = 0;
					el.classes.forEach(udg => {
						if (!udg.totalAmt) udg.totalAmt = 0;
						if (!el[p.partner_code]) el[p.partner_code] = {};

						const idx = el.itemList.findIndex(it => it.partner_code === p.partner_code && it.class_code === udg.class_code);
						const amount = idx > -1 ? el.itemList[idx].amount : 0;
						el[p.partner_code][udg.class_code] = amount;
						print_item_list.push({ class_code: udg.class_code, partner_code: p.partner_code, amount: amount });

						p.totalAmt += el[p.partner_code][udg.class_code];
						udg.totalAmt += el[p.partner_code][udg.class_code];
					});
					sumTotalAmt += p.totalAmt;
				});

				el.sumTotalAmt = sumTotalAmt;
				el.itemList = print_item_list;
			});

			return data;
		},
		reset() {
			this.fromDate = today();
			this.toDate = today();
			this.$refs.salesGroup.reset();
			this.$refs.userDefinedGroup.reset();
		},
		divideByState() {
			const print_list = [];
			this.root.forEach(el => {
				const state_list = [];
				el.partners.forEach(p => {
					const idx = state_list.findIndex(st => st.state === p.address_state);
					if (idx < 0) state_list.push({ state: p.address_state, partners: [p] });
					else state_list[idx].partners.push(p);
				});

				state_list.forEach(st => {
					const new_el = {
						sales_group_code: el.sales_group_code,
						sales_group_name: el.sales_group_name,

						from_date: el.from_date,
						to_date: el.to_date,
						state: st.state,
						partner_cnt: st.partners.length,
						class_cnt: el.class_cnt,

						partners: st.partners,
						classes: _.cloneDeep(this.udg_list),
						itemList: el.itemList.filter(it => st.partners.some(p => p.partner_code === it.partner_code)),
					};
					print_list.push(new_el);
				});
			});

			return print_list;
		},
		getPrintData(root) {
			const print_data = [];
			const partner_cnt_per_page = 10;
			root.forEach(el => {
				const roof_cnt = Math.ceil(el.partner_cnt + 1 / partner_cnt_per_page); // + 1: Total 열 추가
				const partners_copy = [...el.partners];
				const total_obj = { partner_code: '<<TOTAL>>', partner_name: '<<TOTAL>>' };
				partners_copy.push(total_obj);

				const itemList_copy = [...el.itemList];
				// const classes_copy = _.cloneDeep(this.udg_list);
				// classes_copy.forEach(cls => {
				el.classes.forEach(cls => {
					const total_amt = el.itemList.filter(it => it.class_code === cls.class_code).reduce((acc, curr) => acc + curr.amount, 0);
					itemList_copy.push({ class_code: cls.class_code, partner_code: total_obj.partner_code, amount: total_amt });

					// if (total_amt === 0) cls.class_name = '(*) ' + cls.class_name;
				});

				for (let i = 0; i < roof_cnt; i++) {
					const start_idx = partner_cnt_per_page * i;
					const end_idx = partner_cnt_per_page * (i + 1) < partners_copy.length ? partner_cnt_per_page * (i + 1) : partners_copy.length;
					const partners = partners_copy.slice(start_idx, end_idx);
					const itemList = itemList_copy.filter(it => partners.some(p => p.partner_code === it.partner_code));
					const obj = {
						group: true,

						sales_group_code: el.sales_group_code,
						sales_group_name: el.sales_group_name,

						from_date: el.from_date,
						to_date: el.to_date,
						state: el.state,
						partner_cnt: el.partner_cnt,
						class_cnt: el.class_cnt,

						partners: partners,
						// classes: classes_copy,
						classes: _.cloneDeep(this.udg_list),
						itemList: itemList,
					};

					print_data.push(obj);
				}
			});

			return print_data;
		},
		async groupPrint() {
			const print_data = this.getPrintData(this.div_by_state ? this.divideByState() : this.root);
			await reportRenderHorizontally(print_data, 'LandingGroup', reportMrtUrl('LandingRegion'));
		},
		async groupExcelBackUp() {
			const eid = 'excelTable';
			const fileName = 'Landing Group Report';
			exportExcel(eid, fileName);
		},
		groupExcel() {
			const data = [[{ t: 's', v: 'Landing Region Group', cs: 10 }]];
			const root = this.div_by_state ? this.divideByState() : this.root;
			root.forEach(el => {
				// header
				data.push([{ t: 's', v: `${el.sales_group_code} / ${el.sales_group_name}  ${el.from_date} ~ ${el.to_date}   ${el.state ? 'STATE: ' + el.state : ''} / Partner: ${el.partner_cnt} / Item Class: ${el.class_cnt}`, cs: 10 }]);
				const header = [{ t: 's', v: 'Item Class' }];
				el.partners.forEach(p => header.push({ t: 's', v: p.partner_code }));
				header.push({ t: 's', v: 'TOTAL' });
				data.push(header);

				const p_total_arr = [];
				el.classes.forEach(c => {
					const row = [{ t: 's', v: c.class_name }];
					let c_total = 0;
					el.partners.forEach((p, index) => {
						let amount = 0;
						let idx = el.itemList.findIndex(it => it.partner_code === p.partner_code && it.class_code === c.class_code);
						if (idx > -1) {
							amount = el.itemList[idx].amount;
							c_total += amount;
							row.push({ t: 'n', v: amount });
						} else {
							row.push({ t: 's', v: '' }); // { t: 'n', v: null } ??
						}

						if (p_total_arr.length - 1 < index) p_total_arr.push(amount);
						else p_total_arr[index] += amount;
					});
					row.push({ t: 'n', v: c_total });
					data.push(row);
				});

				const p_total_row = p_total_arr.map(pt => ({ t: 'n', v: pt }));
				p_total_row.unshift({ t: 's', v: 'TOTAL' });
				p_total_row.push({ t: 'n', v: p_total_arr.reduce((prev, curr) => prev + curr, 0) });

				data.push(p_total_row);
				data.push([]);
			});

			XLSX.writeFile(
				{
					SheetNames: ['Sheet1'],
					Sheets: {
						Sheet1: excelComplicated(data),
					},
				},
				'LandingRegionGroup.xlsx',
			);

			// XLSX.writeFile(
			// 	{
			// 		SheetNames: ['Sheet1'],
			// 		Sheets: {
			// 			Sheet1: {
			// 				'!ref': 'A1:B2',
			// 				A1: { t: 's', v: 'A1:A2' },
			// 				B1: { t: 'n', v: 1, s: { numFmt: '#,###.00' } }, // number format 안 됨.
			// 				B2: { t: 'b', v: true },
			// 				'!merges': [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } } /* A1:A2 */],
			// 			},
			// 		},
			// 	},
			// 	'test.xlsx',
			// );
		},
		userDefinedGroupAll(value) {
			this.all = value;
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_landingRegionGroup');
		this.$store.commit('setSubTitle', 'Report -> Landing Region Group');
	},
};
</script>

<style scoped></style>
